'use client'

import posthog from 'posthog-js'

const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const host = (import.meta.env.VITE_POSTHOG_HOST as string) || 'https://us.i.posthog.com'

let initialized = false

export function initPostHog() {
  if (initialized || !key || typeof window === 'undefined') return
  posthog.init(key, {
    api_host: host,
    person_profiles: 'identified_only',
    capture_pageview: false, // we handle this manually on route change
  })
  initialized = true
}

export { posthog }
